/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import actions from "./actions";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";

import company from "./company/module.js";
import moduleAuth from "./auth/moduleAuth";
import moduleStep from "./step/moduleStep.js";
import moduleSkills from "./skills/moduleSkills.js";
import moduleTalent from "./talent/moduleTalent.js";
import moduleDiversity from "./diversity/moduleDiversity.js";
import moduleAddress from "./address/moduleAddress.js";
import moduleRevision from "./revision/moduleRevision.js";
import moduleFormation from "./formation/moduleFormation.js";
import moduleProgress from "./progress/moduleProgress.js";
import basicInfo from "./basicInfo/module.js";
import moduleLanguages from "./languages/moduleLanguages.js";
import moduleCurriculum from "./curriculum/moduleCurriculum.js";
import moduleExperiencies from "./experiencies/moduleExperiencies.js";
import moduleInvitationVacancy from "./invitation-vacancy/moduleInvitationVacancy";
import moduleProfessionalProfiles from "./professional_profiles/moduleProfessionalProfiles.js";
import moduleVacancy from "./vacancy/moduleVacancy.js";

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ],
  modules: {
    auth: moduleAuth,
    step: moduleStep,
    skill: moduleSkills,
    talent: moduleTalent,
    company,
    diversity: moduleDiversity,
    address: moduleAddress,
    revision: moduleRevision,
    progress: moduleProgress,
    formation: moduleFormation,
    basicInfo,
    language: moduleLanguages,
    curriculum: moduleCurriculum,
    experience: moduleExperiencies,
    professional_profile: moduleProfessionalProfiles,
    invitation_vacancy: moduleInvitationVacancy,
    vacancy: moduleVacancy
  },
  actions,
  state,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== "production"
});
